import type { ReactElement } from 'react';
import { Box, Menu, Text, UnstyledButton } from '@mantine/core';
import { LogOut } from 'lucide-react';
import { useAuth } from '@/features/auth/AuthContext';

/** The top-nav account control: the user's avatar opening a menu with their identity and logout. */
export default function UserMenuButton(): ReactElement {
    const { user, logout } = useAuth();
    const initials = user?.displayName?.charAt(0).toUpperCase() ?? '?';
    const displayName = user?.displayName ?? 'User';
    const primaryRole = user?.roles[0] ?? 'viewer';

    return (
        <Menu position="bottom-end" width={220} shadow="md" radius="md" withinPortal>
            <Menu.Target>
                <UnstyledButton aria-label="Account menu" title={displayName}>
                    <Box
                        style={{
                            width: 32,
                            height: 32,
                            background: 'var(--mantine-primary-color-filled)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            color: 'white',
                            fontWeight: 700,
                            fontSize: '12px',
                        }}
                    >
                        {initials}
                    </Box>
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                <Box px="sm" py={6}>
                    <Text size="sm" fw={700} lh={1.2}>
                        {displayName}
                    </Text>
                    <Text size="xs" c="dimmed" fw={500} tt="uppercase" style={{ fontSize: '9px', letterSpacing: '0.1em' }}>
                        {primaryRole}
                    </Text>
                </Box>
                <Menu.Divider />
                <Menu.Item leftSection={<LogOut size={14} />} onClick={logout}>
                    Log out
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
}
